import { render, staticRenderFns } from "./ListaNotaFiscal.vue?vue&type=template&id=0b04b4c0&"
import script from "./ListaNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./ListaNotaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports